module.exports = __webpack_public_path__ + "img/tips14.6495e896.png";